{
    "SkyraSurvey.Tittel": "Frivillig spørreundersøkelse",
    "SkyraSurvey.Takk": "Takk for at du svarte på undersøkelsen"
}
